import { useState, useEffect } from 'react';
import classnames from 'classnames';
import { MapContainer, useMapEvents  } from 'react-leaflet';
import { TileLayer } from '@entegral/helpers.leaflet/components';
import { Toolbar } from '../map-search/toolbar';

export function Map({
  accessToken,
  tilesId,

  isLoading,
  isNothing,

  markers,
  bounds,

  onMapInit,
  onViewportEvent,
  openFilters,
}) {
  let className = classnames(`map-search__map`, {
    [`map-search__map_state_loading`]: isLoading,
    [`map-search__map_state_nothing`]: isNothing,
  });

  let isInited = useIsInited(isLoading);

  return (
    <div className={className}>
      {isInited && (
        <MapContainer
          className={`map-search__container`}
          bounds={bounds}
          center={isNothing ? [0,0] : undefined}
          zoom={isNothing ? 13 : undefined}
          maxZoom={18}
          tap={false}
        >
          <MapAdapter onViewportEvent={onViewportEvent} onMapInit={onMapInit} />
          <TileLayer accessToken={accessToken} tilesId={tilesId} />
          {markers}
        </MapContainer>
      )}

      {!isLoading && isNothing ? (
        <div className={`map-search__nothing`}>
          <div className={`map-search__nothing-text`}>
            No listings found, try to adjust your filtering criteria.
          </div>
        </div>
      ) : null}

      <Toolbar openFilters={openFilters} />
    </div>
  );
}

function useIsInited(isLoading) {
  let [isInited, setIsInited] = useState(false);

  useEffect(() => {
    if (isInited || isLoading) return;

    setIsInited(true);
  }, [isLoading]);

  return isInited;
}

function MapAdapter({ onViewportEvent, onMapInit }) {
  let map = useMapEvents({
    moveend: onViewportEvent,
  });

  useEffect(() => {
    onMapInit(map);
  }, []);

  return null;
}
